import React from 'react';
import Select from 'react-select';
import { newCustomAddon, CUSTOM_NAME_MAX } from '../bookingTypeRules';

/**
 * Add-ons for a new booking: catalogue items from the picker, plus CUSTOM
 * add-ons (2026-10-04) where the office types the line's name and net price
 * — the way a maintenance or pool job gets "Pump seal replacement  AED 180"
 * on the invoice without a catalogue item for it. formData.selected_addons
 * is the single source of truth; custom rows carry `custom: true`.
 */
function AddonsSelection({ addons, formData, setFormData }) {
  const selected = formData.selected_addons || [];
  const catalogue = selected.filter((a) => !a.custom);
  const custom = selected.filter((a) => a.custom);
  const setSelected = (list) => setFormData({ ...formData, selected_addons: list });

  const handleAddonsChange = (selectedOptions) => {
    const picked = (selectedOptions || []).map((option) => ({
      id: option.value,
      name: option.label,
      price: option.price,
      quantity: catalogue.find((a) => a.id === option.value)?.quantity || 1,
    }));
    setSelected([...picked, ...custom]);
  };

  const patch = (id, changes) => setSelected(selected.map((a) => (a.id === id ? { ...a, ...changes } : a)));
  const remove = (id) => setSelected(selected.filter((a) => a.id !== id));

  return (
    <div className="form-group">
      <label>Add-ons</label>
      <Select
        options={addons.map((addon) => ({ value: addon.id, label: addon.name, price: addon.default_price }))}
        isMulti
        value={catalogue.map((a) => ({ value: a.id, label: a.name, price: a.price }))}
        onChange={handleAddonsChange}
        placeholder="Select add-ons"
      />

      {selected.length > 0 && (
        <div className="addons-list">
          {selected.map((addon) => (addon.custom ? (
            <div key={addon.id} className="addon-item addon-item--custom">
              <div className="addon-details">
                <input
                  type="text"
                  className="addon-custom-name"
                  value={addon.name}
                  maxLength={CUSTOM_NAME_MAX}
                  placeholder="Name on the invoice, e.g. Pump seal replacement"
                  onChange={(e) => patch(addon.id, { name: e.target.value })}
                />
                <span className="addon-unit-price">Custom add-on · price excl. VAT</span>
              </div>
              <input
                type="number"
                step="0.01"
                min="0"
                value={addon.price}
                placeholder="AED"
                className="addon-custom-price"
                onChange={(e) => patch(addon.id, { price: e.target.value })}
              />
              <input
                type="number"
                step="0.5"
                min="0.5"
                value={addon.quantity}
                className="addon-quantity"
                onChange={(e) => patch(addon.id, { quantity: parseFloat(e.target.value) || 1 })}
              />
              <span className="addon-total-price">{`AED ${((parseFloat(addon.price) || 0) * (parseFloat(addon.quantity) || 0)).toFixed(2)}`}</span>
              <button type="button" className="addon-remove" title="Remove" onClick={() => remove(addon.id)}>×</button>
            </div>
          ) : (
            <div key={addon.id} className="addon-item">
              <div className="addon-details">
                <span className="addon-name">{addon.name}</span>
                <span className="addon-unit-price">{`AED ${addon.price}`}</span>
              </div>
              <input
                type="number"
                step="0.5"
                min="1"
                value={addon.quantity}
                onChange={(e) => patch(addon.id, { quantity: parseFloat(e.target.value) || 1 })}
                className="addon-quantity"
              />
              <span className="addon-total-price">{`AED ${(addon.price * addon.quantity).toFixed(2)}`}</span>
            </div>
          )))}
        </div>
      )}

      <button type="button" className="addon-add-custom" onClick={() => setSelected([...selected, newCustomAddon()])}>
        + Custom add-on
      </button>
    </div>
  );
}

export default AddonsSelection;
